import * as React from 'react'

import { Icon } from '@factorialco/deprecated-design-system'

import Tooltip from 'modules/core/components/Tooltip'

interface Props {
  label: React.ReactNode
}

const InformationTooltip = ({ label }: Props) => {
  return (
    <Tooltip.Alt attachment="bottom center" label={label}>
      <Icon.Medium icon="info-circle-line" color="grey800" />
    </Tooltip.Alt>
  )
}

export default InformationTooltip
